import { AlpineComponent } from 'alpinejs';
import { Collapse } from "bootstrap";

const HASH_OPEN = 'open-cookiebox';
export const EVENT_OPEN = 'DsCookies.Infobox.Open';

type InfoBoxData = {
  acceptAll: () => void,
  categories: { [key: string]: boolean },
  close: () => void,
  closed: boolean,
  detailsCollapse: Collapse | null,
  handleOpenLinkClick: (event: Event) => void,
  open: () => void,
  save: () => void,
  scrollToDetails: () => void,
}

export default ():AlpineComponent<InfoBoxData> => ({
  categories: {},
  closed: false,
  detailsCollapse: null,

  acceptAll() {
    const changeEvent = new Event('change');
    const checkboxes = this.$root.querySelectorAll('input[type="checkbox"]') as NodeListOf<HTMLInputElement>

    [...checkboxes].map(checkbox => {
      checkbox.checked = true;
      checkbox.dispatchEvent(changeEvent);
    });

    this.$nextTick(() => {
      this.save();
    });
  },

  close() {
    this.closed = true;
  },

  handleOpenLinkClick(event: Event) {
    const target = event.target as HTMLLinkElement;

    if (target && target.href) {
      const hash = target.href.split('#')[1];

      if (hash && hash.toLowerCase() === HASH_OPEN) {
        event.preventDefault();

        this.open();
      }
    }
  },

  open() {
    this.closed = false;

    this.$nextTick(() => {
      const focusElement = this.$el.querySelector('a, button') as HTMLInputElement | HTMLButtonElement | null;

      if (focusElement) {
        focusElement.focus();
      }
    });
  },

  save() {
    this.$cookies.save(this.categories);
  },

  scrollToDetails() {
    if (this.$refs.details) {
      this.$refs.details.scrollIntoView({
        behavior: 'smooth',
      });
    }
  },

  init() {
    this.closed = this.$cookies.isSaved();

    this.handleOpenLinkClick = this.handleOpenLinkClick.bind(this); // it's a trick! needed in order to overcome the remove event listener
    this.open = this.open.bind(this); // it's a trick! needed in order to overcome the remove event listener
    this.scrollToDetails = this.scrollToDetails.bind(this); // it's a trick! needed in order to overcome the remove event listener

    document.addEventListener('click', this.handleOpenLinkClick);
    document.addEventListener(EVENT_OPEN, this.open);

    if (this.$refs.details) {
      this.detailsCollapse = new Collapse(this.$refs.details, {
        toggle: false
      });

      this.$refs.details.addEventListener('shown.bs.collapse', this.scrollToDetails);
    }
  },

  destroy() {
    document.removeEventListener('click', this.handleOpenLinkClick);
    document.removeEventListener(EVENT_OPEN, this.open);

    if (this.$refs.details) {
      this.$refs.details.removeEventListener('shown.bs.collapse', this.scrollToDetails);
      this.detailsCollapse?.dispose();
    }
  },
});
